import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { ConversationSummary } from '@/services/api/chatApi';

interface ChatState {
  conversations: ConversationSummary[];
  activeConversationId: string | null;
  isLoadingConversation: boolean;

  setActiveConversation: (id: string | null) => void;
  setConversations: (conversations: ConversationSummary[]) => void;
  setLoadingConversation: (loading: boolean) => void;
  clearChat: () => void;
}

export const useChatStore = create<ChatState>()(
  devtools(
    set => ({
      conversations: [],
      activeConversationId: null,
      isLoadingConversation: false,

      setActiveConversation: id =>
        set({ activeConversationId: id }, false, 'chat/setActiveConversation'),

      setConversations: conversations => set({ conversations }, false, 'chat/setConversations'),

      setLoadingConversation: loading =>
        set({ isLoadingConversation: loading }, false, 'chat/setLoadingConversation'),

      clearChat: () =>
        set(
          {
            activeConversationId: null,
            isLoadingConversation: false,
          },
          false,
          'chat/clearChat'
        ),
    }),
    { name: 'ChatStore', enabled: import.meta.env.DEV }
  )
);
